import React, { Component, Fragment } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Card,
  Upload,
  Icon,
  message,
  Switch,
} from "antd";
import Wrapper from "containers/backend/common/component/Wrapper";
import Ripple from "containers/backend/common/component/Ripple";
import * as HMS from "../../../../common/component/Index";
import TranslateButton from "../../../../common/component/TranslateButton";
import * as Func from "../../../../../../helpers/functions";
import DEFINE, {
  PATHS,
  FEATURE_FLAGS,
  UPLOAD_DIRECTORY,
} from "constants/Define";
import FnbProduct from "../../../../../../models/FnbProduct";
import UploadImage from "containers/backend/common/component/UploadImage";
import i18n from "constants/initLng";
import { get, isEqual } from "lodash";

const FormItem = Form.Item;
const { TextArea } = Input;

const emptyProduct = {
  id: null,
  code: "",
  name: "",
  shortName: "",
  totalPrice: 0,
  description: "",
  imageUrls: [],
  image: "",
  isActive: true,
  languageCode: "vi-VN",
  translations: [],
};

class ProductDetail extends Component {
  state = {
    product: emptyProduct,
  };

  componentDidMount() {
    const { id } = this.props.match.params;
    if (id) {
      this.props.getProductDetail(id);
    }
  }

  componentDidUpdate(prevProps) {
    const { fnbState } = this.props;
    const prevFnbState = prevProps.fnbState;

    if (
      prevFnbState.currentProduct !== fnbState.currentProduct &&
      fnbState.currentProduct
    ) {
      const product = this.normalizeProductDetail(fnbState.currentProduct);
      this.setState({ product });
    }

    if (
      prevFnbState.updating &&
      !fnbState.updating &&
      !fnbState.error &&
      this.state.product.languageCode === "vi-VN"
    ) {
      message.success("Cập nhật sản phẩm thành công!");
      this.handleCancel();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.uploadState.file &&
      !isEqual(nextProps.uploadState.file, this.props.uploadState.file)
    ) {
      const { file } = nextProps.uploadState;
      const imageUrl = file.data?.fileUrl || file.fileUrl || file;
      if (imageUrl && typeof imageUrl === "string") {
        this.setState((prevState) => ({
          product: {
            ...prevState.product,
            imageUrls: [...(prevState.product.imageUrls || []), imageUrl],
          },
        }));
      }
    }
  }

  normalizeProductDetail = (productDetail) => {
    const translations = productDetail.translations || [];
    const defaultLang = translations.find((item) => item.isDefault);
    const languageCode =
      (defaultLang && defaultLang.languageCode) ||
      productDetail.languageCode ||
      "vi-VN";
    const name =
      this.getTranslationName(translations, languageCode) ||
      productDetail.name ||
      "";
    const shortName =
      this.getTranslationField(translations, languageCode, "shortName") ||
      productDetail.shortName ||
      "";
    const description =
      this.getTranslationField(translations, languageCode, "description") ||
      productDetail.description ||
      "";

    return {
      ...productDetail,
      translations,
      languageCode,
      name,
      shortName,
      description,
      imageUrls: productDetail.imageUrls || [],
    };
  };

  getTranslationName = (translations, languageCode) => {
    const translation = (translations || []).find(
      (item) => item.languageCode === languageCode,
    );
    return translation ? translation.name : "";
  };

  getTranslationField = (translations, languageCode, field) => {
    const translation = (translations || []).find(
      (item) => item.languageCode === languageCode,
    );
    return translation ? translation[field] : "";
  };

  getDefaultLanguageCode = () => {
    const { product } = this.state;
    const defaultLang = (product.translations || []).find(
      (item) => item.isDefault,
    );
    return (
      (defaultLang && defaultLang.languageCode) ||
      product.languageCode ||
      "vi-VN"
    );
  };

  handleInputChange = (field, value) => {
    this.setState((prevState) => ({
      product: {
        ...prevState.product,
        [field]: value,
      },
    }));
  };

  handleShowTranslate = (language) => {
    if (!language || !language.code) return;
    this.setState((prevState) => ({
      product: {
        ...prevState.product,
        languageCode: language.code,
        name: this.getTranslationField(
          prevState.product.translations,
          language.code,
          "name",
        ),
        shortName: this.getTranslationField(
          prevState.product.translations,
          language.code,
          "shortName",
        ),
        description: this.getTranslationField(
          prevState.product.translations,
          language.code,
          "description",
        ),
      },
    }));
  };

  handleExitTranslate = () => {
    const defaultLangCode = this.getDefaultLanguageCode();
    this.setState((prevState) => ({
      product: {
        ...prevState.product,
        languageCode: defaultLangCode,
        name: this.getTranslationField(
          prevState.product.translations,
          defaultLangCode,
          "name",
        ),
        shortName: this.getTranslationField(
          prevState.product.translations,
          defaultLangCode,
          "shortName",
        ),
        description: this.getTranslationField(
          prevState.product.translations,
          defaultLangCode,
          "description",
        ),
      },
    }));
  };

  handleRemoveTranslate = (language) => {
    if (!language || !language.code) return;
    const translation = (this.state.product.translations || []).find(
      (item) => item.languageCode === language.code,
    );
    if (translation && translation.id) {
      this.props.deleteProductTranslateById({
        translateId: translation.id,
        productId: this.state.product.id,
        languageCode: language.code,
        languageName: this.props.t(`translate.languages.${language.id}`),
      });
      return;
    }
    this.setState((prevState) => {
      const translations = (prevState.product.translations || []).filter(
        (item) => item.languageCode !== language.code,
      );
      const defaultLanguageCode = this.getDefaultLanguageCode();
      const nextLanguageCode =
        prevState.product.languageCode === language.code
          ? defaultLanguageCode
          : prevState.product.languageCode;
      return {
        product: {
          ...prevState.product,
          translations,
          languageCode: nextLanguageCode,
          name: this.getTranslationName(translations, nextLanguageCode),
          shortName: this.getTranslationField(
            translations,
            nextLanguageCode,
            "shortName",
          ),
          description: this.getTranslationField(
            translations,
            nextLanguageCode,
            "description",
          ),
        },
      };
    });
  };

  handleSubmit = (e) => {
    if (e) e.preventDefault();
    const { product } = this.state;
    const { id } = this.props.match.params;
    const productId = id || product.id;

    if (!productId) return;

    const defaultLanguageCode = this.getDefaultLanguageCode();
    if (
      product.languageCode &&
      product.languageCode !== "vi-VN" &&
      product.languageCode !== defaultLanguageCode
    ) {
      const translation = (product.translations || []).find(
        (item) => item.languageCode === product.languageCode,
      );
      this.props.translateProduct({
        id: productId,
        translateId: translation?.id,
        isUpdate: !!translation?.id,
        name: product.name || "",
        shortName: product.shortName || "",
        description: product.description || "",
        languageCode: product.languageCode,
        languageName: this.props.t(
          `translate.languages.${product.languageCode.split("-")[0]}`,
        ),
      });
      return;
    }

    const translateDefaultData = (product.translations || []).find(
      (item) => item.isDefault,
    );
    this.props.updateProduct({
      id: productId,
      code: product.code,
      imageUrls: product.imageUrls,
      isActive: product.isActive,
      translations: [
        {
          ...translateDefaultData,
          name: product.name,
          shortName: product.shortName,
          description: product.description,
        },
        ...(product.translations || []).filter((item) => !item.isDefault),
      ],
    });
  };

  handleCancel = () => {
    this.props.history.push(PATHS.FNB.PRODUCT.LIST.path);
  };

  onUploadImages = (file) => {
    let fileData = file.target.files;
    const { product } = this.state;
    const existingCount = (product.imageUrls || []).length;

    if (fileData.length + existingCount > 8) {
      message.error(
        Func.formatValidation(i18n.t("validation.statusCode.code.5"), 8),
      );
      return false;
    }

    let imageValidation = ["image/jpeg", "image/jpg", "image/png"];
    Object.keys(fileData).map((i) => {
      if (imageValidation.includes(fileData[i].type)) {
        this.props.onUploadFile({
          file: fileData[i],
          directory: UPLOAD_DIRECTORY.IMAGES,
          isFile: 2,
        });
      } else {
        message.error(i18n.t("validation.image"));
      }
    });
  };

  removeImages = (url, index) => {
    this.setState((prevState) => ({
      product: {
        ...prevState.product,
        imageUrls: (prevState.product.imageUrls || []).filter(
          (_, i) => i !== index,
        ),
      },
    }));
  };

  onChangeImagesOrder = (newImageUrls) => {
    this.handleInputChange("imageUrls", newImageUrls);
  };

  getThumbSources(thumbs) {
    return (thumbs || [])
      .filter((t) => t)
      .map((t) => {
        const url = typeof t === "object" ? t.url : t;
        return url && url.startsWith("http")
          ? url
          : `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${url}`;
      });
  }

  render() {
    const { t, fnbState, uploadState } = this.props;
    const { loading, updating, productTranslateLoading } = fnbState;
    const { product } = this.state;

    const isTranslate =
      product.languageCode &&
      product.languageCode !== this.getDefaultLanguageCode();

    return (
      <Fragment>
        <HMS.LoadingComponent spinning={loading}>
          <HMS.PageListComponent>
            <HMS.HeaderListComponent
              path={this.props.match.path}
              groupPath="fnb"
              group="product"
              titleHeader={t("fnb.product.updateTitle", {
                defaultValue: "Cập nhật chi tiết sản phẩm",
              })}
              componentRight={
                <Wrapper
                  style={{ display: "flex", alignItems: "center", gap: 16 }}
                >
                  {FEATURE_FLAGS.TRANSLATE_ENABLE && product && (
                    <TranslateButton
                      languages={product.translations || []}
                      current={product.languageCode || "vi-VN"}
                      onChange={this.handleShowTranslate}
                      onClear={this.handleExitTranslate}
                      onRemove={this.handleRemoveTranslate}
                    />
                  )}
                </Wrapper>
              }
            />
            <Card bordered={false} bodyStyle={{ padding: "24px" }}>
              <Form onSubmit={this.handleSubmit} layout="vertical">
                <Row gutter={24}>
                  <Col span={12}>
                    <FormItem label="Mã sản phẩm">
                      <Input disabled value={product.code || ""} />
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Tên sản phẩm">
                      <Input
                        value={product.name}
                        onChange={(e) =>
                          this.handleInputChange("name", e.target.value)
                        }
                      />
                    </FormItem>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col span={12}>
                    <FormItem label="Tên ngắn">
                      <Input
                        value={product.shortName}
                        onChange={(e) =>
                          this.handleInputChange("shortName", e.target.value)
                        }
                      />
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Giá">
                      <Input
                        type="number"
                        disabled={true}
                        value={product.totalPrice}
                      />
                    </FormItem>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col span={24}>
                    <FormItem label="Thực đơn">
                      <Input disabled value={product.menu || ""} />
                    </FormItem>
                  </Col>
                </Row>

                {/* <Row gutter={24}>
                  <Col span={24}>
                    <FormItem label="Nhóm gia vị">
                      <Input disabled value={product.condimentGroup || ""} />
                    </FormItem>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col span={24}>
                    <FormItem label="Nhóm tùy chọn">
                      <Input disabled value={product.optionGroup || ""} />
                    </FormItem>
                  </Col>
                </Row> */}

                <Row gutter={24}>
                  <Col span={17}>
                    <FormItem label="Mô tả">
                      <TextArea
                        rows={8}
                        value={product.description}
                        onChange={(e) =>
                          this.handleInputChange("description", e.target.value)
                        }
                      />
                    </FormItem>
                  </Col>
                  <Col span={7}>
                    <FormItem label="Hình ảnh sản phẩm">
                      <UploadImage
                        multiple={true}
                        loading={uploadState?.isFetchingMultiple}
                        thumbnailSize={120}
                        buttonSize={120}
                        disabledUpload={uploadState?.isFetchingMultiple}
                        disabledRemove={uploadState?.isFetchingMultiple}
                        uploadText={t("item.golf.uploadFile")}
                        loadingText={t("item.golf.uploading")}
                        onChange={this.onUploadImages}
                        onRemoveThumbnail={this.removeImages}
                        thumbnails={this.getThumbSources(
                          product.imageUrls || [],
                        )}
                        allowChangeOrder={true}
                        onChangeOrder={this.onChangeImagesOrder}
                      />
                      <div
                        style={{ marginTop: 8, color: "#999", fontSize: 12 }}
                      >
                        JPG, PNG, GIF. Tối đa 5MB. Có thể tải lên nhiều ảnh.
                      </div>
                    </FormItem>
                  </Col>
                </Row>

                <Row>
                  <Col span={24} style={{ textAlign: "center", marginTop: 20 }}>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <span>
                        {t("common.active", { defaultValue: "Hoạt động" })}
                      </span>
                      <Switch
                        checked={product.isActive}
                        onChange={(checked) =>
                          this.handleInputChange("isActive", checked)
                        }
                        disabled={true}
                      />
                    </div>
                    <Button
                      style={{ marginRight: 8 }}
                      onClick={this.handleCancel}
                    >
                      {t("action.cancel", { defaultValue: "Hủy" })}
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={updating || productTranslateLoading}
                    >
                      {isTranslate
                        ? t("action.save", { defaultValue: "Lưu" })
                        : t("action.update", { defaultValue: "Cập nhật" })}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card>
          </HMS.PageListComponent>
        </HMS.LoadingComponent>
      </Fragment>
    );
  }
}

export default ProductDetail;
